import React from "react";
import { fileUrl } from "@/lib/files";
import { ImageOff } from "lucide-react";

export function FileImage({ fileId, alt = "", className = "", fallback = null, testId }) {
  const url = fileUrl(fileId);
  if (!url) {
    if (fallback) return <img src={fallback} alt={alt} className={className} data-testid={testId} />;
    return (
      <div className={`flex items-center justify-center bg-muted text-muted-foreground ${className}`} data-testid={testId}>
        <ImageOff strokeWidth={1.5} className="w-8 h-8 opacity-40" />
      </div>
    );
  }
  return <img src={url} alt={alt} className={className} data-testid={testId} />;
}
